import { GTMEvent } from '~/lib/gtm/GTM'

export const adaptSubscribeToNewsletter = () => {
  return {
    event: GTMEvent.SUBSCRIBE_TO_NEWSLETTER,
  }
}
